import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {ICollectionWorkProject, ICollectionWorkProjectSaveParams} from './useCollectionWorkProject';
import {IContest} from './useContest';
import {CollectionWorkProjectStatusConfig} from './useCollectionWorkProjectRecord';

export enum CollectionWorkProjectType {
  文档 = 1,
  图片 = 2,
}

export interface ICollectionWork {
  id: number;
  contest: IContest;
  remark: string;
  beginTime: string;
  endTime: string;
  statusConfig: CollectionWorkProjectStatusConfig;
}

export interface ICollectionWorkSaveParams {
  id: number;
  beginTime: string;
  endTime: string;
  statusConfig: CollectionWorkProjectStatusConfig;
}

export default class UseCollectionWork {
  static save() {
    return usePost<ICollectionWorkSaveParams, ICollectionWork>('collectionWork/save', {});
  }

  static queryById() {
    return useGet<IQueryByIdParams, ICollectionWork>('collectionWork/queryById', {});
  }
}
